// ── 多场景应急预案注册表 ──
// 本文件是所有应急 GIS 场景数据的统一入口。
// 每个场景对应一个独立的 emergencyMapData_<name>.js 文件，
// 包含该地区的完整地理坐标、洪水动画配置和应急资源信息。
//
// 用法：
//   import { getActiveScenario, switchScenario, SCENARIOS } from '@/services/emergencyMapData.js'
//   switchScenario('yanchang')          // 切换到延长县场景
//   const data = getActiveScenario()    // 获取当前激活场景的 GIS 数据
//
// 向后兼容：仍导出 EMERGENCY_GIS_DATA（指向初始激活场景的数据），
// 但建议使用 getActiveScenario() 以确保获取最新场景。

import { LONGMEN_GIS_DATA } from './emergencyMapData_longmen.js'
import { YANCHANG_GIS_DATA } from './emergencyMapData_yanchang.js'

// ── 场景注册表 ──
export const SCENARIOS = {
  longmen: {
    key: 'longmen',
    name: '龙门镇禹门口',
    river: '黄河',
    region: '陕西韩城',
    description: '黄河出晋陕峡谷的咽喉，龙门镇沿河片区洪水应急联动',
    defaultPlanName: '龙门镇禹门口沿河片区防汛应急联动方案',
    data: LONGMEN_GIS_DATA,
  },
  yanchang: {
    key: 'yanchang',
    name: '延长县县城',
    river: '延河',
    region: '陕西延安',
    description: '延河穿城而过，延长县县城山洪防御与人员转移联动',
    defaultPlanName: '延长县县城延河沿线片区防汛应急联动方案',
    data: YANCHANG_GIS_DATA,
  },
}

// ── 当前激活场景 ──
let _activeKey = 'longmen'

/**
 * 获取当前激活场景的 GIS 数据
 * @returns {Object} 当前场景的 EMERGENCY_GIS_DATA 对象
 */
export function getActiveScenario() {
  return SCENARIOS[_activeKey].data
}

/**
 * 获取当前激活场景的 key
 * @returns {string}
 */
export function getActiveScenarioKey() {
  return _activeKey
}

/**
 * 获取当前激活场景的元信息（名称、河流、区域等）
 * @returns {Object}
 */
export function getActiveScenarioInfo() {
  const s = SCENARIOS[_activeKey]
  return { key: s.key, name: s.name, river: s.river, region: s.region, description: s.description, defaultPlanName: s.defaultPlanName }
}

/**
 * 切换激活场景
 * @param {string} key - 场景 key（'longmen' | 'yanchang'）
 * @returns {boolean} 是否切换成功
 */
export function switchScenario(key) {
  if (SCENARIOS[key]) {
    _activeKey = key
    return true
  }
  console.warn(`[emergencyMapData] 未知场景 key: ${key}`)
  return false
}

/**
 * 获取所有可用场景列表
 * @returns {Array<{key, name, river, region, description}>}
 */
export function listScenarios() {
  return Object.values(SCENARIOS).map(s => ({
    key: s.key,
    name: s.name,
    river: s.river,
    region: s.region,
    description: s.description,
    defaultPlanName: s.defaultPlanName,
  }))
}

// ── 向后兼容导出 ──
// 注意：这是初始值的快照，切换场景后不会自动更新。
// 如需动态获取当前场景数据，请使用 getActiveScenario()。
export const EMERGENCY_GIS_DATA = LONGMEN_GIS_DATA
